<template>
  <div class="relative">
    <!-- Item active: "text-gray-900", Item inactive: "text-gray-500" -->
    <button
      type="button"
      @click="open = !open"
      class=" w-64 group bg-vectric p-2 rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2"
      aria-expanded="false"
    >
      <span class="w-full text-left">Filter By Product</span>
      <!--
        Heroicon name: solid/chevron-down

        Item active: "text-gray-600", Item inactive: "text-gray-400"
      -->
      <svg
        class="text-darkBlue ml-2 h-5 w-5 group-hover:text-gray-500"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <!--    <transition-group-->
    <!--      enter-class="transition ease-out duration-200"-->
    <!--      enter-active-class="opacity-0 translate-y-1"-->
    <!--      enter-to-class="opacity-100 translate-y-0"-->
    <!--      leave-class="transition ease-in duration-150"-->
    <!--      leave-active-class="opacity-100 translate-y-0"-->
    <!--      leave-to-class="opacity-0 translate-y-1"-->
    <!--    >-->
    <div
      v-on-clickaway="close"
      v-if="open"
      class="absolute z-10 left-1/2 transform -translate-x-1/2 mt-1 px-2 w-64 sm:px-0"
    >
      <div
        class=" bg-white px-4 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden border-2 border-darkBlue"
      >
        <fieldset class=" py-2">
          <div
            class="relative flex items-center"
            v-for="option in options"
            :key="option"
          >
            <div class="flex items-center">
              <input
                type="checkbox"
                class="focus:ring-lighterblue h-4 w-4 text-red border-gray-300 rounded"
                :value="option"
                v-model="myModel"
              />
            </div>
            <div class="ml-3">
              <label class="font-semibold text-lg text-gray-700">
                {{ option }}
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <!--    </transition-group>-->
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  name: "ProductFilter",
  props: {
    value: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      open: false,
      myModel: [],
      options: [
        "Aspire",
        "VCarve Pro",
        "VCarve Desktop",
        "Cut2D Desktop",
        "Cut2D Pro"
      ]
    };
  },
  watch: {
    myModel() {
      console.log("Watch called");
      this.$emit("input", this.myModel);
    }
  },
  methods: {
    close() {
      this.open = false;
    }
  }
};
</script>

<style scoped></style>
